import { render, staticRenderFns } from "./NewsfeedMain.vue?vue&type=template&id=5ee3c66a&scoped=true"
import script from "./NewsfeedMain.vue?vue&type=script&lang=js"
export * from "./NewsfeedMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee3c66a",
  null
  
)

export default component.exports